import {RouteDefinition} from '../../../../routes';
import {SetupMatchScreen} from './SetupMatchScreen';

export const SetupRoutes: RouteDefinition[] = [
    {
        routerLink: '/settings/gateway/:id/setup/match',
        component: SetupMatchScreen,
    },
];
